export var DEFAULT_AUTO_SCROLL_INTERVAL = 8000;
export var DEFAULT_SLIDE_DURATION_MS = 1000;
export var SHOW_INDICATORS_THRESHOLD = 14;
export var ARROW_POSITION = {
  center: 'center',
  top: 'top',
  bottom: 'bottom'
};
export var INDICATORS_POSITION = {
  top: 'top',
  bottom: 'bottom'
};
export var MAX_INDICATORS_DISPLAY = 12;
export var MAX_INDICATORS_MOBILE_DISPLAY = 7;